<template>
    <div class="question-show xy-start">
        <slot name="start"></slot>
        <div v-html="content"></div>
        <slot name="end"></slot>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: String,
            default: "",
        },
        start: {
            type: String,
        },
    },
    computed: {
        content() {
            if (this.start) {
                return this.start + this.data;
            } else {
                return this.data;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.question-show ::v-deep {
    text-align: left;
    line-height: 30px;
    p {
        margin: 0 !important;
    }
    img {
        max-width: 120px;
    }
}
</style>
